(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jba-jewel-viewer"] && !Shopify.designMode) return;
  try {
    function jbaGeometryFactory() {
const TAU = Math.PI * 2;
const clamp = (value, min, max) => Math.max(min, Math.min(max, Number.isFinite(Number(value)) ? Number(value) : min));
const add = (a, b) => a.map((v, i) => v + b[i]);
const sub = (a, b) => a.map((v, i) => v - b[i]);
const mul = (a, s) => a.map(v => v * s);
const cross = (a, b) => [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
const norm = a => mul(a, 1 / (Math.hypot(...a) || 1));
const mix = (a, b, t) => a.map((v, i) => v + (b[i] - v) * t);
const shapes = ['round', 'oval', 'emerald', 'radiant', 'cushion', 'pear', 'marquise', 'heart', 'asscher', 'princess'];

function outline(shape, count = 32) {
  const name = String(shape).toLowerCase();
  const points = [];
  const polygon = name === 'emerald' || name === 'radiant' || name === 'asscher' || name === 'princess';
  for (let i = 0; i < count; i++) {
    const angle = TAU * i / count;
    let x = Math.cos(angle), z = Math.sin(angle);
    if (polygon) {
      const corners = name === 'princess' ? [[-1, -1], [1, -1], [1, 1], [-1, 1]] : [[-.68, -1], [.68, -1], [1, -.68], [1, .68], [.68, 1], [-.68, 1], [-1, .68], [-1, -.68]];
      const progress = i / count * corners.length;
      const start = corners[Math.floor(progress)], end = corners[(Math.floor(progress) + 1) % corners.length];
      x = start[0] + (end[0] - start[0]) * (progress % 1);
      z = start[1] + (end[1] - start[1]) * (progress % 1);
      if (name === 'emerald' || name === 'radiant') { x *= .77; z *= 1.12; }
      else { x *= .87; z *= .87; }
    } else if (name === 'oval') { x *= .85; z *= 1.19; }
    else if (name === 'cushion') { x = Math.sign(x) * Math.pow(Math.abs(x), .62) * .93; z = Math.sign(z) * Math.pow(Math.abs(z), .62) * .99; }
    else if (name === 'pear') { x *= .78 * (.72 + .28 * Math.sin(angle)); z *= 1.25; }
    else if (name === 'marquise') { x = Math.sign(x) * Math.pow(Math.abs(x), 1.5) * .66; z *= 1.44; }
    else if (name === 'heart') {
      x = 16 * Math.pow(Math.sin(angle), 3) / 17;
      z = -(13 * Math.cos(angle) - 5 * Math.cos(2 * angle) - 2 * Math.cos(3 * angle) - Math.cos(4 * angle)) / 17;
    }
    points.push([x, z]);
  }
  return points;
}

class Mesh {
  constructor(options = {}) { this.data = []; this.triangles = 0; this.lowDetail = Boolean(options.lowDetail); this.tinyStones = /tennis|eternity/.test(options.category || ''); }
  triangle(a, b, c, material = 0, smooth = null) {
    const normal = norm(cross(sub(b, a), sub(c, a)));
    if (Math.hypot(...normal) < .1) return;
    [a, b, c].forEach((point, i) => this.data.push(...point, ...(smooth ? smooth[i] : normal), material));
    this.triangles++;
  }
  tube(points, radius = .2, sides = 8, flatten = 1, closed = false) {
    if (this.lowDetail) {
      sides = radius < .5 ? 3 : 6;
      if (points.length > 32) points = points.filter((_, index) => index % Math.ceil(points.length / 32) === 0);
    }
    const rings = points.map((point, i) => {
      const previous = points[i ? i - 1 : (closed ? points.length - 1 : 0)];
      const next = points[i === points.length - 1 ? (closed ? 0 : i) : i + 1];
      const tangent = norm(sub(next, previous));
      const first = norm(cross(tangent, Math.abs(tangent[2]) > .9 ? [0, 1, 0] : [0, 0, 1]));
      const second = norm(cross(tangent, first));
      return Array.from({length: sides}, (_, j) => {
        const angle = TAU * j / sides;
        const offset = add(mul(first, Math.cos(angle) * radius), mul(second, Math.sin(angle) * radius * flatten));
        return {p: add(point, offset), n: norm(add(mul(first, Math.cos(angle)), mul(second, Math.sin(angle) / flatten)))};
      });
    });
    for (let i = 0; i < rings.length - (closed ? 0 : 1); i++) {
      const ring = rings[i], next = rings[(i + 1) % rings.length];
      for (let j = 0; j < sides; j++) {
        const k = (j + 1) % sides, a = ring[j], b = ring[k], c = next[j], d = next[k];
        const quadNormal = this.lowDetail ? norm(add(add(a.n, b.n), add(c.n, d.n))) : null;
        this.triangle(a.p, c.p, b.p, 0, quadNormal ? [quadNormal, quadNormal, quadNormal] : [a.n, c.n, b.n]);
        this.triangle(b.p, c.p, d.p, 0, quadNormal ? [quadNormal, quadNormal, quadNormal] : [b.n, c.n, d.n]);
      }
    }
    if (!closed) {
      for (const i of [0, rings.length - 1]) for (let j = 0; j < sides; j++) this.triangle(points[i], rings[i][j].p, rings[i][(j + 1) % sides].p);
    }
  }
  sphere(center, radius, segments = 8) {
    if (this.lowDetail && radius < .4) return;
    if (this.lowDetail) segments = 4;
    const point = (i, j) => {
      const normal = [Math.sin(Math.PI * i / segments) * Math.cos(TAU * j / segments), Math.cos(Math.PI * i / segments), Math.sin(Math.PI * i / segments) * Math.sin(TAU * j / segments)];
      return {p: add(center, mul(normal, radius)), n: normal};
    };
    for (let i = 0; i < segments; i++) for (let j = 0; j < segments; j++) {
      const a = point(i, j), b = point(i + 1, j), c = point(i, j + 1), d = point(i + 1, j + 1);
      this.triangle(a.p, b.p, c.p, 0, [a.n, b.n, c.n]);
      this.triangle(c.p, b.p, d.p, 0, [c.n, b.n, d.n]);
    }
  }
  gem(center, size, shape, up = [0, 1, 0], rotation = 0) {
    const normal = norm(up);
    let right = norm(cross(normal, Math.abs(normal[2]) > .9 ? [1, 0, 0] : [0, 0, 1]));
    let forward = norm(cross(right, normal));
    const oldRight = right;
    right = add(mul(right, Math.cos(rotation)), mul(forward, Math.sin(rotation)));
    forward = add(mul(forward, Math.cos(rotation)), mul(oldRight, -Math.sin(rotation)));
    const transform = (x, y, z) => add(center, add(mul(right, x), add(mul(normal, y), mul(forward, z))));
    const points = outline(shape, this.lowDetail ? (this.tinyStones ? 8 : 16) : size < 3.3 ? 16 : 32);
    const radius = size / 2;
    const ring = (scale, height) => points.map(([x, z]) => transform(x * radius * scale, height * size, z * radius * scale));
    const table = ring(.55, .205), crown = ring(.77, .115), girdle = ring(1, 0), lower = ring(.995, -.035);
    const stepCut = /emerald|asscher/i.test(shape);
    const pavilion = ring(stepCut ? .58 : .40, -.25);
    const tip = transform(0, -.45 * size, 0), top = transform(0, .205 * size, 0);
    const facet = (a, b, c) => this.triangle(a, b, c, 1);
    for (let i = 0; i < points.length; i++) {
      const n = (i + 1) % points.length;
      facet(top, table[i], table[n]);
      if (this.lowDetail && this.tinyStones) {
        facet(table[i], girdle[i], table[n]); facet(table[n], girdle[i], girdle[n]); facet(girdle[i], tip, girdle[n]);
        continue;
      }
      if (i % 2 === 0 && !stepCut) {
        const nn = (i + 2) % points.length;
        facet(table[i], crown[n], table[nn]);
        facet(table[i], crown[i], crown[n]);
        facet(table[nn], crown[n], crown[nn]);
      } else if (stepCut) {
        facet(table[i], crown[i], table[n]); facet(table[n], crown[i], crown[n]);
      }
      facet(crown[i], girdle[i], crown[n]); facet(crown[n], girdle[i], girdle[n]);
      facet(girdle[i], lower[i], girdle[n]); facet(girdle[n], lower[i], lower[n]);
      facet(lower[i], pavilion[i], lower[n]); facet(lower[n], pavilion[i], pavilion[n]);
      facet(pavilion[i], tip, pavilion[n]);
    }
    return {transform, outline: points, radius, size};
  }
  setting(center, size, shape, options = {}) {
    const gem = this.gem(center, size, shape, options.up, options.rotation);
    const convert = (point, height = 0, scale = 1) => gem.transform(point[0] * gem.radius * scale, height * size, point[1] * gem.radius * scale);
    const bezel = /bezel|channel/.test(options.style || '');
    if (bezel) {
      const rim = gem.outline.map(point => convert(point, -.005, 1.05));
      this.tube(rim, Math.max(.13, size * .035), size < 3.3 ? 5 : 7, 1, true);
      const base = gem.outline.map(point => convert(point, -.24, .78));
      this.tube(base, Math.max(.12, size * .03), 6, 1, true);
      const supportCount = this.lowDetail ? 4 : 8;
      for (let i = 0; i < supportCount; i++) {
        const point = gem.outline[Math.round(i * gem.outline.length / supportCount)];
        this.tube([convert(point, -.27, .68), convert(point, -.06, 1.05)], Math.max(.10, size * .026), 6);
      }
    } else {
      const number = /six/.test(options.style || '') ? 6 : /three-prong|martini/.test(options.style || '') ? 3 : /two-prong/.test(options.style || '') ? 2 : 4;
      const polygonShape = /emerald|radiant|asscher|princess/i.test(shape);
      for (let i = 0; i < number; i++) {
        const index = Math.round((i / number + (polygonShape ? 0 : .125)) * gem.outline.length) % gem.outline.length;
        const point = gem.outline[index];
        const topPoint = convert(point, .045, 1.015);
        this.tube([convert(point, -.32, .50), convert(point, -.08, 1.08), topPoint], Math.max(.12, size * .028), size < 3.3 ? 5 : 7);
        this.sphere(topPoint, Math.max(.14, size * .029), size < 3.3 ? 4 : 6);
      }
      const basket = gem.outline.filter((_, index) => !this.lowDetail || index % 2 === 0).map(point => convert(point, -.17, .78));
      this.tube(basket, Math.max(.09, size * .021), size < 3.3 ? 4 : 6, 1, true);
    }
    return gem;
  }
}

function* jewelrySteps(input = {}) {
  const config = {
    category: input.category || 'engagement-rings', style: String(input.style || 'solitaire').toLowerCase(),
    shape: shapes.includes(String(input.shape || '').toLowerCase()) ? String(input.shape).toLowerCase() : 'round',
    carat: clamp(input.carat || 2, .10, 50), width: clamp(input.width || 2, 1.3, 5), ringSize: clamp(input.ringSize || 6.5, 3, 13), length: clamp(input.length || (input.category === 'tennis-necklaces' ? 18 : 7), 5, 24), metal: input.metal || '14K White Gold', handPreview: Boolean(input.handPreview)
  };
  const mesh = new Mesh(input);
  const size = 6.5 * Math.cbrt(config.carat);
  const ringRadius = (11.63 + config.ringSize * .8128) / 2;
  const ringPath = (radius, offset = 0, begin = config.handPreview ? -Math.PI / 2 : 0, end = config.handPreview ? Math.PI / 2 : TAU, count = 80) => Array.from({length: count}, (_, i) => { const a = begin + (end - begin) * i / count; return [Math.sin(a) * radius, Math.cos(a) * radius, offset]; });
  const bandRadius = .72;
  const band = (radius, offset = 0, width = config.width) => mesh.tube(ringPath(radius, offset), bandRadius, 10, width / (bandRadius * 2), !config.handPreview);
  if (config.category === 'engagement-rings') {
    if (/split/.test(config.style)) {
      for (const sign of [-1, 1]) mesh.tube(ringPath(ringRadius).map(point => [point[0], point[1], sign * Math.max(0, point[1] / ringRadius) * config.width * .66]), .58, 9, .9, !config.handPreview);
    } else if (/twist/.test(config.style)) {
      for (const sign of [-1, 1]) mesh.tube(ringPath(ringRadius).map(point => [point[0], point[1], sign * config.width * .42 * Math.cos(4 * Math.atan2(point[0], point[1]))]), .49, 8, 1, !config.handPreview);
    } else if (/knife/.test(config.style)) mesh.tube(ringPath(ringRadius), .88, 4, config.width / 1.6, !config.handPreview);
    else band(ringRadius);
    yield;
    const center = [0, ringRadius + size * .48 + .68, 0];
    const rotation = /east-west/.test(config.style) ? Math.PI / 2 : 0;
    mesh.setting(center, size, config.shape, {style: config.style, rotation});
    for (const xSign of [-1, 1]) for (const zSign of [-1, 1]) {
      const x = xSign * Math.min(size * .22, ringRadius * .55);
      const foot = [x, Math.sqrt(Math.max(0, ringRadius * ringRadius - x * x)) + .48, 0];
      mesh.tube([foot, [xSign * size * .24, center[1] - size * .32, zSign * size * .24]], Math.max(.20, config.width * .12), 7);
    }
    if (/cathedral|tulip|petal/.test(config.style)) {
      for (const sign of [-1, 1]) {
        const path = [[sign * ringRadius * .85, ringRadius * .50, 0], [sign * size * .62, ringRadius + .60, 0], [sign * size * .30, center[1] - size * .20, 0]];
        mesh.tube(path, .54, 9, 1);
      }
    }
    if (/tulip|petal/.test(config.style)) {
      for (let i = 0; i < 4; i++) {
        const angle = Math.PI * .25 + i * Math.PI * .5;
        const path = Array.from({length: 12}, (_, step) => {
          const t = step / 11, radial = size * (.12 + .43 * Math.sin(t * Math.PI * .5));
          return [Math.cos(angle) * radial, center[1] + size * (-.44 + .46 * t), Math.sin(angle) * radial];
        });
        mesh.tube(path, size * .029, 7);
      }
    }
    if (/three-stone|trilogy/.test(config.style)) {
      const sideSize = size * .52;
      for (const sign of [-1, 1]) {
        const x = sign * size * .74;
        mesh.setting([x, center[1] - size * .23, 0], sideSize, /emerald/.test(config.shape) ? 'emerald' : config.shape, {style: 'prong', up: norm([sign * .24, 1, 0])});
        const footX = sign * Math.min(size * .74, ringRadius * .82);
        const footY = Math.sqrt(Math.max(0, ringRadius * ringRadius - footX * footX)) + .50;
        for (const side of [-1, 1]) mesh.tube([[footX, footY, side * config.width * .25], [x, center[1] - size * .23 - sideSize * .27, side * sideSize * .20]], .38, 7);
      }
    }
    if (/halo/.test(config.style)) {
      const hidden = /hidden/.test(config.style), small = size * .105;
      const pointOutline = outline(config.shape, 20);
      for (const [x, z] of pointOutline) {
        const sx = x * size * (hidden ? .44 : .64), sz = z * size * (hidden ? .44 : .64);
        const normal = hidden ? norm([sx, .30, sz]) : [0, 1, 0];
        mesh.gem([sx, center[1] + (hidden ? -.12 : -.015) * size, sz], small, 'round', normal, rotation);
      }
    }
    if (/pave|halo|twist/.test(config.style)) {
      for (const sign of [-1, 1]) for (let i = 0; i < 8; i++) {
        const angle = sign * (.43 + i * .105), normal = [Math.sin(angle), Math.cos(angle), 0];
        mesh.gem(mul(normal, ringRadius + .65), Math.min(config.width * .70, 1.4), 'round', normal);
        if (i % 4 === 3) yield;
      }
    }
  } else if (config.category === 'eternity-bands') {
    const count = Math.round(clamp(input.stoneCount || 20, 12, 32));
    const stoneSize = Math.min(6.5 * Math.cbrt(config.carat / count), TAU * (ringRadius + 1.4) / count * .96);
    band(ringRadius, 0, Math.max(config.width, stoneSize * .68));
    for (let i = 0; i < count; i++) {
      const a = TAU * i / count, up = [Math.sin(a), Math.cos(a), 0];
      if (config.handPreview && up[1] < -.001) continue;
      mesh.setting(mul(up, ringRadius + stoneSize * .3 + .4), stoneSize, config.shape, {style: config.style, up, rotation: /east-west/.test(config.style) ? Math.PI / 2 : 0});
      if (i % 2 === 1) yield;
    }
    if (/channel/.test(config.style)) for (const side of [-1, 1]) mesh.tube(ringPath(ringRadius + stoneSize * .34, side * stoneSize * .56), .3, 8, 1, !config.handPreview);
  } else if (config.category === 'diamond-studs') {
    const stoneSize = 6.5 * Math.cbrt(config.carat / 2);
    for (const sign of [-1, 1]) {
      const center = [sign * stoneSize * .75, 1.8, sign * .6];
      mesh.setting(center, stoneSize, config.shape, {style: config.style});
      mesh.tube([[center[0], center[1] - stoneSize * .27, center[2]], [center[0], center[1] - stoneSize * .27 - 6, center[2]]], .28, 10);
      const back = Array.from({length: 32}, (_, i) => [center[0] + Math.cos(TAU * i / 32) * 1.3, center[1] - stoneSize * .27 - 4.5, center[2] + Math.sin(TAU * i / 32) * 1.3]);
      mesh.tube(back, .28, 7, 1, true);
      for (const side of [-1, 1]) mesh.sphere([center[0] + side * 1.0, center[1] - stoneSize * .27 - 4.5, center[2]], .52, 8);
    }
  } else {
    const necklace = config.category === 'tennis-necklaces';
    const count = Math.round(clamp(input.stoneCount || (necklace ? 76 : 48), 24, 100));
    const stoneSize = 6.5 * Math.cbrt(config.carat / count);
    const spacing = stoneSize * 1.09;
    const radius = spacing * count / TAU * config.length / (necklace ? 18 : 7);
    const ratio = necklace ? 1.19 : .87;
    const depth = necklace ? .89 : 1.13;
    const points = [];
    for (let i = 0; i < count; i++) {
      const a = TAU * i / count;
      const graduation = /graduat/.test(config.style) ? 1.0 + .22 * Math.cos(a) : 1;
      const center = [Math.sin(a) * radius * ratio, necklace ? .20 * Math.cos(a) : .7 * Math.sin(a), Math.cos(a) * radius * depth];
      points.push([center[0], center[1] - stoneSize * .25, center[2]]);
      mesh.setting(center, stoneSize * graduation, config.shape, {style: config.style, rotation: /east-west/.test(config.style) ? Math.PI / 2 + a : a});
      if (i % 2 === 1) yield;
    }
    mesh.tube(points, .18, 6, 1, true);
    const clasp = [0, -.6, -radius * depth];
    mesh.tube([add(clasp, [-stoneSize * 1.2, 0, 0]), add(clasp, [-stoneSize * 1.2, 0, -stoneSize]), add(clasp, [stoneSize * 1.2, 0, -stoneSize]), add(clasp, [stoneSize * 1.2, 0, 0])], .42, 8);
    mesh.tube([add(clasp, [stoneSize * .5, .3, -stoneSize]), add(clasp, [stoneSize * .5, .9, -stoneSize * 1.7]), add(clasp, [-stoneSize * .5, .9, -stoneSize * 1.7]), add(clasp, [-stoneSize * .5, .3, -stoneSize])], .22, 7);
  }
  const bounds = {min: [Infinity, Infinity, Infinity], max: [-Infinity, -Infinity, -Infinity]};
  for (let i = 0; i < mesh.data.length; i += 7) for (let j = 0; j < 3; j++) { bounds.min[j] = Math.min(bounds.min[j], mesh.data[i + j]); bounds.max[j] = Math.max(bounds.max[j], mesh.data[i + j]); }
  const center = mix(bounds.min, bounds.max, .5);
  const radius = config.handPreview ? ringRadius * (config.category === 'eternity-bands' ? 1.4 : 1.45) : Math.hypot(...sub(bounds.max, bounds.min)) * .5;
  return {vertices: new Float32Array(mesh.data), triangles: mesh.triangles, bounds, center, radius, config};
}

function makeJewelry(input) { const steps = jewelrySteps(input); let step; do { step = steps.next(); } while (!step.done); return step.value; }
async function makeJewelryAsync(input) { const steps = jewelrySteps({...input, lowDetail: true}); let step; do { step = steps.next(); if (!step.done) await new Promise(resolve => setTimeout(resolve, 0)); } while (!step.done); return step.value; }

return {makeJewelry, makeJewelryAsync, norm, sub, add, cross, clamp};

}
const {makeJewelryAsync, norm, sub, add, cross, clamp} = jbaGeometryFactory();

function jbaSoftwareFactory() {
  function geometry(state, vertices) {
    state.vertices = vertices;
    state.projected = new Float32Array(vertices.length / 7 * 3);
    state.faces = Array.from({length:vertices.length / 21}, (_, index) => {
      const i=index*21;
      const nx=vertices[i+3]+vertices[i+10]+vertices[i+17], ny=vertices[i+4]+vertices[i+11]+vertices[i+18], nz=vertices[i+5]+vertices[i+12]+vertices[i+19];
      const length=Math.hypot(nx,ny,nz)||1;
      return {index,depth:0,nx:nx/length,ny:ny/length,nz:nz/length,gem:vertices[i+6]>.5};
    });
  }
  function* steps(state, request) {
    const started=performance.now(), {matrix,camera,target,width,height,metal,light}=request, {vertices,projected,faces,context,canvas}=state;
    if(canvas.width!==width||canvas.height!==height){canvas.width=width;canvas.height=height;}
    context.clearRect(0,0,width,height);
    for(let i=0,p=0;i<vertices.length;i+=7,p+=3){
      const x=vertices[i],y=vertices[i+1],z=vertices[i+2],w=matrix[3]*x+matrix[7]*y+matrix[11]*z+matrix[15];
      projected[p]=(matrix[0]*x+matrix[4]*y+matrix[8]*z+matrix[12])/w*width*.5+width*.5;
      projected[p+1]=height*.5-(matrix[1]*x+matrix[5]*y+matrix[9]*z+matrix[13])/w*height*.5;
      projected[p+2]=w;
      if(i>0&&i%21000===0)yield;
    }
    for(const face of faces){const p=face.index*9;face.depth=(projected[p+2]+projected[p+5]+projected[p+8])/3;}
    faces.sort((a,b)=>b.depth-a.depth);
    let vx=camera[0]-target[0],vy=camera[1]-target[1],vz=camera[2]-target[2];
    const length=Math.hypot(vx,vy,vz)||1;vx/=length;vy/=length;vz/=length;
    const lx=-.42+light[0],ly=.82,lz=.45+light[1],colors=new Map();
    let painted=0;
    for(const face of faces){
      if(face.depth<=0)continue;
      let {nx,ny,nz}=face,facing=nx*vx+ny*vy+nz*vz;
      if(facing<0){nx=-nx;ny=-ny;nz=-nz;facing=-facing;}
      const rx=2*facing*nx-vx,ry=2*facing*ny-vy,rz=2*facing*nz-vz;
      const shine=Math.pow(Math.max(0,rx*lx+ry*ly+rz*lz),36);
      let red,green,blue,key;
      if(face.gem){
        const facet=.68+.32*Math.abs(Math.sin(nx*19+nz*13+ny*7));
        const brilliance=(.60+.27*Math.abs(ry)+.16*facing)*facet+shine*.7;
        key=5000+Math.round(brilliance*255);
        red=brilliance*.96;green=brilliance*.99;blue=brilliance*1.04;
      }else{
        const reflection=.70+.15*Math.abs(ry)+.08*facing;
        key=Math.round(reflection*255)*16+Math.min(15,Math.round(shine*15));
        red=reflection*metal[0]+shine*.20;green=reflection*metal[1]+shine*.20;blue=reflection*metal[2]+shine*.20;
      }
      let color=colors.get(key);
      if(!color){color='rgb('+Math.min(255,Math.round(Math.max(0,red)*255))+','+Math.min(255,Math.round(Math.max(0,green)*255))+','+Math.min(255,Math.round(Math.max(0,blue)*255))+')';colors.set(key,color);}
      const p=face.index*9;
      context.beginPath();context.moveTo(projected[p],projected[p+1]);context.lineTo(projected[p+3],projected[p+4]);context.lineTo(projected[p+6],projected[p+7]);context.closePath();context.fillStyle=color;context.fill();
      if(++painted%300===0)yield;
    }
    return Math.round(performance.now()-started);
  }
  function paint(state,request){const iterator=steps(state,request);let step;do{step=iterator.next();}while(!step.done);return step.value;}
  async function paintAsync(state,request){const iterator=steps(state,request);let step;do{step=iterator.next();if(!step.done)await new Promise(resolve=>setTimeout(resolve,0));}while(!step.done);return step.value;}
  return {geometry,paint,paintAsync};
}

const jbaSoftware = jbaSoftwareFactory();

const vertexSource = `
precision mediump float;
attribute vec3 aPosition;
attribute vec3 aNormal;
attribute float aMaterial;
uniform mat4 uMatrix;
varying vec3 vPosition;
varying vec3 vNormal;
varying float vMaterial;
void main() {
  vPosition = aPosition;
  vNormal = aNormal;
  vMaterial = aMaterial;
  gl_Position = uMatrix * vec4(aPosition, 1.0);
}`;

const fragmentSource = `
precision mediump float;
varying vec3 vPosition;
varying vec3 vNormal;
varying float vMaterial;
uniform vec3 uCamera;
uniform vec3 uMetal;
uniform vec2 uLight;
vec3 studio(vec3 ray) {
  float upper = smoothstep(-0.65, 0.9, ray.y);
  vec3 result = mix(vec3(0.28, 0.29, 0.30), vec3(0.97, 0.96, 0.94), upper);
  float dark = smoothstep(0.93, 0.995, abs(dot(ray, normalize(vec3(0.85, 0.1, -0.35)))));
  result *= 1.0 - dark * 0.84;
  float strip = pow(max(0.0, dot(ray, normalize(vec3(-0.75 + uLight.x, 0.65, 0.85 + uLight.y)))), 46.0);
  float edge = pow(max(0.0, dot(ray, normalize(vec3(0.9, 0.7, -0.6)))), 95.0);
  return result + vec3(1.6) * strip + vec3(1.7, 1.55, 1.35) * edge;
}
void main() {
  vec3 normal = normalize(vNormal);
  vec3 view = normalize(uCamera - vPosition);
  if (dot(normal, view) < 0.0) normal = -normal;
  vec3 reflected = reflect(-view, normal);
  float facing = max(0.0, dot(normal, view));
  vec3 color;
  if (vMaterial > 0.5) {
    vec3 inside = refract(-view, normal, 0.417);
    vec3 bounce = reflect(inside, normalize(vec3(normal.x * 1.17 + 0.12, -normal.y * 0.92, normal.z * 1.22 - 0.08)));
    vec3 brilliance = studio(bounce);
    float facets = 0.64 + 0.36 * abs(sin(normal.x * 19.0 + normal.z * 13.0 + normal.y * 7.0));
    float fresnel = 0.17 + 0.83 * pow(1.0 - facing, 4.0);
    color = mix(brilliance * facets, studio(reflected), fresnel);
    color = color * vec3(0.95, 0.99, 1.04) + vec3(0.12, 0.14, 0.16);
    float fire = pow(max(0.0, dot(reflected, normalize(vec3(-0.5, 0.8, 0.9)))), 150.0);
    vec3 spectral = 0.5 + 0.5 * cos(vec3(0.0, 2.1, 4.2) + (normal.x + normal.z) * 24.0);
    color += spectral * fire * 1.6;
    float flash = pow(max(0.0, dot(reflected, normalize(vec3(0.7, 0.85, 0.2)))), 220.0);
    color += vec3(2.5) * flash;
  } else {
    float fresnel = 0.28 + 0.72 * pow(1.0 - facing, 3.0);
    color = studio(reflected) * uMetal * (0.78 + fresnel * 0.32);
    color += uMetal * 0.12;
  }
  color = color / (color + vec3(0.35));
  color = pow(max(color, vec3(0.0)), vec3(0.75));
  gl_FragColor = vec4(color, 1.0);
}`;

function matrixMultiply(a, b) {
  const result = new Float32Array(16);
  for (let column = 0; column < 4; column++) for (let row = 0; row < 4; row++) for (let i = 0; i < 4; i++) result[column * 4 + row] += a[i * 4 + row] * b[column * 4 + i];
  return result;
}

function cameraMatrix(camera, target, aspect, near, far) {
  const z = norm(sub(camera, target));
  const x = norm(cross([0, 1, 0], z));
  const y = cross(z, x);
  const dot = (a, b) => a.reduce((sum, v, i) => sum + v * b[i], 0);
  const view = new Float32Array([x[0], y[0], z[0], 0, x[1], y[1], z[1], 0, x[2], y[2], z[2], 0, -dot(x, camera), -dot(y, camera), -dot(z, camera), 1]);
  const f = 1 / Math.tan(.62 / 2);
  const perspective = new Float32Array([f / aspect, 0, 0, 0, 0, f, 0, 0, 0, 0, (far + near) / (near - far), -1, 0, 0, 2 * far * near / (near - far), 0]);
  return matrixMultiply(perspective, view);
}

class JBAJewelViewer extends HTMLElement {
  constructor() {
    super();
    this.config = {category: 'engagement-rings', style: 'solitaire', shape: 'round', carat: 2, metal: '14K White Gold', width: 2, ringSize: 6.5, length: 7};
    this.angle = {yaw: .55, pitch: .38, zoom: 1};
    this.pointers = new Map();
    this.active = false;
    this.playing = false;
    this.visible = false;
    this.light = [0, 0];
    this.frame = 0;
    this.build = 0;
    this.needsGeometry = true;
    this.ready = new Promise(resolve => { this.resolveReady = resolve; });
  }
  connectedCallback() {
    if (this.controller) return;
    this.canvas = this.querySelector('canvas');
    this.status = this.querySelector('[data-viewer-status]');
    this.startButton = this.querySelector('[data-viewer-start]');
    this.controls = this.querySelector('[data-viewer-controls]');
    if (!this.canvas) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.configure({category: this.dataset.category || this.config.category});
    if (this.dataset.config) { try { this.configure(JSON.parse(this.dataset.config)); } catch {} }
    this.setView(this.getAttribute('view') || 'three-quarter');
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-viewer-action]');
      if (!button) return;
      const action = button.dataset.viewerAction;
      if (action === 'activate') this.activate();
      else if (action === 'in') this.zoom(.15);
      else if (action === 'out') this.zoom(-.15);
      else if (action === 'play') this.setPlaying(!this.playing);
      else if (action === 'reset') { this.angle.zoom = 1; this.setView('three-quarter'); }
      else this.setView(action);
    }, {signal});
    this.addEventListener('pointerdown', event => {
      if (event.target !== this.canvas) return;
      if (!this.active || event.button > 0) return;
      this.canvas.focus({preventScroll: true});
      this.canvas.setPointerCapture(event.pointerId);
      this.pointers.set(event.pointerId, {x: event.clientX, y: event.clientY});
      this.setPlaying(false);
      this.dataset.dragging = 'true';
      if (this.pointers.size === 2) this.pinchDistance = this.pointerDistance();
    }, {signal});
    this.addEventListener('pointermove', event => {
      if (event.target !== this.canvas) return;
      const last = this.pointers.get(event.pointerId);
      if (last) {
        this.pointers.set(event.pointerId, {x: event.clientX, y: event.clientY});
        if (this.pointers.size === 2) {
          const distance = this.pointerDistance();
          if (this.pinchDistance) this.zoom((distance - this.pinchDistance) / 250);
          this.pinchDistance = distance;
        } else {
          this.angle.yaw -= (event.clientX - last.x) * .009;
          this.angle.pitch = clamp(this.angle.pitch + (event.clientY - last.y) * .009, -1.55, 1.55);
          this.requestDraw();
        }
      } else if (this.active && !this.reduced.matches && event.pointerType === 'mouse') {
        const box = this.canvas.getBoundingClientRect();
        this.light = [(event.clientX - box.left) / box.width * .4 - .2, (event.clientY - box.top) / box.height * .4 - .2];
        this.requestDraw();
      }
    }, {signal});
    const release = event => { this.pointers.delete(event.pointerId); this.pinchDistance = 0; if (!this.pointers.size) delete this.dataset.dragging; };
    this.addEventListener('pointerup', release, {signal});
    this.addEventListener('pointercancel', release, {signal});
    this.addEventListener('lostpointercapture', release, {signal});
    this.addEventListener('keydown', event => {
      if (event.target !== this.canvas) return;
      const keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', '+', '=', '-', '_', 'Home', ' '];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') { this.angle.zoom = 1; this.setView('three-quarter'); }
      else if (event.key === ' ') this.setPlaying(!this.playing);
      else if (event.key === '+' || event.key === '=') this.zoom(.15);
      else if (event.key === '-' || event.key === '_') this.zoom(-.15);
      else {
        this.setPlaying(false);
        this.angle.yaw += event.key === 'ArrowLeft' ? .12 : event.key === 'ArrowRight' ? -.12 : 0;
        this.angle.pitch = clamp(this.angle.pitch + (event.key === 'ArrowUp' ? .12 : event.key === 'ArrowDown' ? -.12 : 0), -1.55, 1.55);
        this.requestDraw();
      }
    }, {signal});
    this.canvas.addEventListener('webglcontextlost', event => {
      event.preventDefault();
      this.lost = true;
      this.setPlaying(false);
      cancelAnimationFrame(this.frame); this.frame = 0;
      this.showStatus(this.dataset.unavailable, true);
      this.dispatchEvent(new CustomEvent('jba:viewer-error', {bubbles: true, detail: {reason: 'context-lost'}}));
    }, {signal});
    this.canvas.addEventListener('webglcontextrestored', () => {
      this.lost = false; this.gl = null; this.program = null; this.buffer = null; this.needsGeometry = true;
      if (this.active) this.scheduleBuild();
    }, {signal});
    document.addEventListener('visibilitychange', () => { if (document.hidden) { cancelAnimationFrame(this.frame); this.frame = 0; } else this.requestDraw(); }, {signal});
    this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.setPlaying(false); }, {signal});
    this.observer = new IntersectionObserver(entries => {
      this.visible = entries[0].isIntersecting;
      if (this.visible && this.active) { if (this.needsGeometry) this.scheduleBuild(); else this.requestDraw(); }
      else { cancelAnimationFrame(this.frame); this.frame = 0; }
    }, {threshold: .01});
    this.observer.observe(this);
    this.resizeObserver = new ResizeObserver(() => { if (this.active) this.requestDraw(); });
    this.resizeObserver.observe(this.canvas);
    if (this.hasAttribute('active')) this.activate();
  }
  disconnectedCallback() {
    this.controller?.abort(); this.controller = null;
    this.observer?.disconnect(); this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.frame); this.frame = 0;
    clearTimeout(this.build); this.build = 0;
    this.releaseGPU(); this.needsGeometry = true;
  }
  pointerDistance() { const [a, b] = this.pointers.values(); return a && b ? Math.hypot(a.x - b.x, a.y - b.y) : 0; }
  configure(next = {}) {
    const previousGeometry = JSON.stringify({...this.config, metal: ''});
    this.config = {...this.config, ...next};
    const changed = previousGeometry !== JSON.stringify({...this.config, metal: ''});
    if (changed) this.geometryVersion = (this.geometryVersion || 0) + 1;
    this.needsGeometry = this.needsGeometry || changed;
    this.metal = /rose/i.test(this.config.metal) ? [1.0, .60, .48] : /yellow/i.test(this.config.metal) ? [1.0, .78, .37] : /platinum/i.test(this.config.metal) ? [.88, .91, .96] : [.93, .95, 1.0];
    if (/18/.test(this.config.metal) && /yellow/i.test(this.config.metal)) this.metal = [1.0, .73, .30];
    if (this.active) { if (this.needsGeometry) this.scheduleBuild(); else this.requestDraw(); }
    return this;
  }
  activate() {
    this.active = true;
    this.dataset.active = 'true';
    if (this.canvas) {
      this.canvas.tabIndex = this.hasAttribute('transparent') ? -1 : 0;
      if (this.hasAttribute('transparent')) this.canvas.setAttribute('aria-hidden', 'true');
      else this.canvas.removeAttribute('aria-hidden');
    }
    if (this.startButton) this.startButton.hidden = true;
    this.showStatus(this.dataset.loading);
    this.scheduleBuild();
    return this.ready;
  }
  deactivate() {
    this.active = false;
    this.setPlaying(false);
    cancelAnimationFrame(this.frame); this.frame = 0;
    clearTimeout(this.build); this.build = 0;
    return this;
  }
  setView(view = 'three-quarter') {
    const wide = /tennis/.test(this.config.category);
    this.angle.yaw = view === 'profile' ? Math.PI / 2 : view === 'top' ? 0 : .55;
    this.angle.pitch = view === 'top' ? 1.55 : view === 'profile' ? .04 : wide ? .92 : .38;
    this.currentView = view === 'perspective' ? 'three-quarter' : view;
    this.querySelectorAll('[data-viewer-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.viewerAction === this.currentView)));
    this.setPlaying(false);
    this.requestDraw();
    return this;
  }
  zoom(delta) { this.angle.zoom = clamp(this.angle.zoom + Number(delta || 0), .65, 2.7); this.requestDraw(); return this; }
  play(value) { return this.setPlaying(value); }
  setPlaying(value) {
    this.playing = Boolean(value) && this.active && !this.reduced?.matches;
    const button = this.querySelector('[data-viewer-action="play"]');
    if (button) { button.setAttribute('aria-pressed', String(this.playing)); button.textContent = this.playing ? this.dataset.pause : this.dataset.rotate; }
    this.requestDraw(); return this;
  }
  showStatus(text, error = false) {
    if (this.status) { this.status.textContent = text || ''; this.status.hidden = !text; }
    this.dataset.error = String(error);
  }
  scheduleBuild() {
    if (this.build || this.building || !this.active || !this.isConnected || this.lost) return;
    this.build = setTimeout(() => {
      this.build = 0;
      if (!this.active || !this.isConnected || !this.getBoundingClientRect().width || !this.getBoundingClientRect().height) return;
      requestAnimationFrame(() => requestAnimationFrame(async () => {
        if (!this.active || !this.isConnected) return;
        this.building = true;
        const version = this.geometryVersion || 0;
        try {
          if (!this.gl && !this.canvasSoftware) this.initializeRenderer();
          if (this.needsGeometry) {
            this.showStatus(this.dataset.loading);
            this.canvas.setAttribute('aria-busy', 'true');
            const scene = await this.generateGeometry();
            if (!scene || !this.active || !this.isConnected || version !== (this.geometryVersion || 0)) return;
            this.scene = scene;
            this.sceneVersion = version;
            this.vertexCount = this.scene.vertices.length / 7;
            if (this.gl) {
              this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.buffer);
              this.gl.bufferData(this.gl.ARRAY_BUFFER, this.scene.vertices, this.gl.STATIC_DRAW);
            } else {
              if(this.renderWorker) this.renderWorker.postMessage({type:'geometry',vertices:this.scene.vertices},[this.scene.vertices.buffer]);
              else jbaSoftware.geometry(this.softwareState,this.scene.vertices);
            }
            this.scene.vertices = null;
            this.needsGeometry = false;
          }
          this.draw();
          if(this.gl)this.finishReady();
        } catch (error) {
          this.dataset.errorReason = String(error?.message || error || 'unknown').slice(0, 1000);
          this.showStatus(this.dataset.unavailable, true);
          this.active = false;
          this.dispatchEvent(new CustomEvent('jba:viewer-error', {bubbles: true, detail: {reason: 'unavailable'}}));
        } finally {
          this.building = false;
          if (this.active && this.needsGeometry) this.scheduleBuild();
        }
      }));
    }, 45);
  }
  generateGeometry() {
    if (this.workerUnavailable) return makeJewelryAsync(this.config);
    if (!this.worker) {
      const source = 'const {makeJewelry}=(' + jbaGeometryFactory.toString() + ')();self.onmessage=function(event){try{const scene=makeJewelry(event.data);self.postMessage({scene},[scene.vertices.buffer]);}catch(error){self.postMessage({error:true});}};';
      const url = URL.createObjectURL(new Blob([source], {type: 'text/javascript'}));
      try { this.worker = new Worker(url); }
      catch (error) { this.dataset.workerReason = String(error?.message || error).slice(0, 500); this.workerUnavailable = true; return makeJewelryAsync(this.config); }
      finally { URL.revokeObjectURL(url); }
      this.worker.onmessage = event => {
        clearTimeout(this.workerTimeout);
        const resolve = this.workerResolve, reject = this.workerReject;
        this.workerResolve = null; this.workerReject = null;
        if (event.data.error) reject?.(new Error('Geometry unavailable'));
        else resolve?.(event.data.scene);
      };
      this.worker.onerror = event => {
        clearTimeout(this.workerTimeout);
        this.workerReject?.(new Error('Worker: ' + (event.message || 'blocked or unavailable')));
        this.workerResolve = null; this.workerReject = null;
        this.worker?.terminate(); this.worker = null;
      };
    }
    return new Promise((resolve, reject) => {
      this.workerResolve = resolve; this.workerReject = reject;
      this.workerTimeout = setTimeout(() => { reject(new Error('Geometry unavailable')); this.worker?.terminate(); this.worker = null; }, 20000);
      this.worker.postMessage({...this.config, lowDetail: Boolean(this.canvasSoftware)});
    }).catch(error => {
      this.dataset.workerReason = String(error?.message || error).slice(0, 500);
      this.workerUnavailable = true;
      this.worker?.terminate(); this.worker = null;
      return makeJewelryAsync(this.config);
    });
  }
  initializeRenderer() {
    try { this.initializeGL(); this.dataset.rendererEngine = 'webgl'; }
    catch (error) {
      this.dataset.hardwareReason = String(error?.message || error).slice(0, 1000);
      if (this.gl) {
        if (this.buffer) this.gl.deleteBuffer(this.buffer);
        if (this.program) this.gl.deleteProgram(this.program);
        this.gl = null; this.buffer = null; this.program = null;
        const canvas = this.canvas.cloneNode(false);
        this.canvas.replaceWith(canvas); this.canvas = canvas;
      }
      this.canvasSoftware = true;
      this.dataset.rendererEngine = 'canvas-3d';
      this.initializeSoftware();
    }
  }
  initializeSoftware() {
    if(typeof OffscreenCanvas!=='undefined'&&typeof Worker!=='undefined'&&this.canvas.transferControlToOffscreen){
      const source='const api=('+jbaSoftwareFactory.toString()+')();let state;self.onmessage=function(event){const message=event.data;try{if(message.type==="init"){state={canvas:message.canvas,context:message.canvas.getContext("2d",{alpha:true})};if(!state.context)throw new Error("Offscreen2D unavailable");self.postMessage({type:"initialized"});}else if(message.type==="geometry"){api.geometry(state,message.vertices);}else if(message.type==="frame"){const duration=api.paint(state,message.request);self.postMessage({type:"painted",duration,version:message.request.version});}}catch(error){self.postMessage({type:"error",reason:String(error.message||error)});}};';
      const url=URL.createObjectURL(new Blob([source],{type:'text/javascript'}));
      try{
        this.renderWorker=new Worker(url);
        this.renderWorker.onmessage=event=>{
          const message=event.data;
          if(message.type==='error'){this.fallbackSoftwareWorker(message.reason);return;}
          if(message.type==='initialized')this.dataset.rendererThread='worker';
          if(message.type==='painted')this.finishSoftwarePaint(message);
        };
        this.renderWorker.onerror=event=>this.fallbackSoftwareWorker(event.message||'Offscreen worker unavailable');
        const canvas=this.canvas.transferControlToOffscreen();
        this.canvasTransferred=true;
        this.renderWorker.postMessage({type:'init',canvas},[canvas]);
        this.dataset.rendererThread='worker';
        return;
      }catch(error){this.dataset.renderWorkerReason=String(error?.message||error).slice(0,500);this.renderWorker?.terminate();this.renderWorker=null;}
      finally{URL.revokeObjectURL(url);}
    }
    this.initializeSoftwareMain();
  }
  initializeSoftwareMain(){
    if(this.canvasTransferred){const canvas=this.canvas.cloneNode(false);this.canvas.replaceWith(canvas);this.canvas=canvas;this.canvasTransferred=false;}
    this.context2d=this.canvas.getContext('2d',{alpha:true});
    if(!this.context2d)throw new Error('Canvas graphics unavailable');
    const buffer=document.createElement('canvas');
    this.softwareState={canvas:buffer,context:buffer.getContext('2d',{alpha:true})};
    this.dataset.rendererThread='cooperative-main';
  }
  fallbackSoftwareWorker(reason){
    this.dataset.renderWorkerReason=String(reason).slice(0,500);
    this.renderWorker?.terminate();this.renderWorker=null;this.softwareBusy=false;this.latestSoftwareFrame=null;
    try{this.initializeSoftwareMain();this.needsGeometry=true;this.scheduleBuild();}
    catch(error){this.dataset.errorReason=String(error?.message||error).slice(0,500);this.showStatus(this.dataset.unavailable,true);}
  }
  finishReady(){
    this.showStatus('');this.canvas.removeAttribute('aria-busy');this.resolveReady(this);
    if(this.announcedVersion===(this.sceneVersion||0))return;
    this.announcedVersion=this.sceneVersion||0;
    this.dispatchEvent(new CustomEvent('jba:viewer-ready',{bubbles:true,detail:{config:{...this.config},triangles:this.scene.triangles}}));
  }
  initializeGL() {
    const gl = this.canvas.getContext('webgl', {alpha: true, antialias: true, depth: true, premultipliedAlpha: false, powerPreference: 'low-power'});
    if (!gl) throw new Error('WebGL unavailable');
    this.gl = gl;
    const compile = (kind, source) => { const shader = gl.createShader(kind); gl.shaderSource(shader, source); gl.compileShader(shader); return shader; };
    const vertex = compile(gl.VERTEX_SHADER, vertexSource), fragment = compile(gl.FRAGMENT_SHADER, fragmentSource);
    this.program = gl.createProgram();
    gl.attachShader(this.program, vertex); gl.attachShader(this.program, fragment); gl.linkProgram(this.program);
    if (!gl.getProgramParameter(this.program, gl.LINK_STATUS)) {
      const reason = [gl.getProgramInfoLog(this.program), gl.getShaderInfoLog(vertex), gl.getShaderInfoLog(fragment)].filter(Boolean).join(' / ');
      gl.deleteShader(vertex); gl.deleteShader(fragment);
      throw new Error('WebGL shader link: ' + (reason || 'unknown'));
    }
    gl.deleteShader(vertex); gl.deleteShader(fragment);
    gl.useProgram(this.program);
    this.buffer = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
    for (const [name, size, offset] of [['aPosition', 3, 0], ['aNormal', 3, 12], ['aMaterial', 1, 24]]) {
      const position = gl.getAttribLocation(this.program, name);
      gl.enableVertexAttribArray(position); gl.vertexAttribPointer(position, size, gl.FLOAT, false, 28, offset);
    }
    this.uniforms = {};
    for (const name of ['uMatrix', 'uCamera', 'uMetal', 'uLight']) this.uniforms[name] = gl.getUniformLocation(this.program, name);
    gl.enable(gl.DEPTH_TEST); gl.depthFunc(gl.LEQUAL);
    gl.clearColor(0, 0, 0, 0);
  }
  releaseGPU() {
    clearTimeout(this.workerTimeout);
    this.workerResolve?.(null); this.workerResolve = null; this.workerReject = null;
    this.worker?.terminate(); this.worker = null;
    this.renderWorker?.terminate();this.renderWorker=null;this.softwareBusy=false;this.latestSoftwareFrame=null;
    this.context2d = null;this.softwareState=null;this.canvasSoftware=false;
    if (!this.gl) return;
    if (this.buffer) this.gl.deleteBuffer(this.buffer);
    if (this.program) this.gl.deleteProgram(this.program);
    this.buffer = null; this.program = null; this.gl = null;
  }
  requestDraw() {
    if (this.frame || !this.active || (!this.gl && !this.canvasSoftware) || !this.scene || this.lost || !this.visible || document.hidden) return;
    this.frame = requestAnimationFrame(timestamp => {
      this.frame = 0;
      if (this.playing) { this.angle.yaw += Math.min(50, timestamp - (this.lastTime || timestamp)) * .00022; this.lastTime = timestamp; }
      else this.lastTime = 0;
      this.draw();
      if (this.playing) this.requestDraw();
    });
  }
  draw() {
    if (!this.active || (!this.gl && !this.canvasSoftware) || !this.scene || this.lost || document.hidden) return;
    const gl = this.gl, box = this.canvas.getBoundingClientRect();
    if (!box.width || !box.height) return;
    const ratio = this.canvasSoftware ? 1 : Math.min(devicePixelRatio || 1, 1.7);
    const width = Math.max(1, Math.round(Math.min(box.width, 1000) * ratio));
    const height = Math.max(1, Math.round(Math.min(box.height, 1000) * ratio));
    if (!this.canvasTransferred&&(this.canvas.width !== width || this.canvas.height !== height)) { this.canvas.width = width; this.canvas.height = height; }
    const aspect = width / height;
    const radius = this.scene.radius;
    const distance = radius * (aspect < 1 ? 3.8 / aspect : 3.8) / this.angle.zoom;
    const target = this.scene.center;
    const camera = add(target, [Math.sin(this.angle.yaw) * Math.cos(this.angle.pitch) * distance, Math.sin(this.angle.pitch) * distance, Math.cos(this.angle.yaw) * Math.cos(this.angle.pitch) * distance]);
    const matrix = cameraMatrix(camera, target, aspect, radius * .015, radius * 30);
    if (this.canvasSoftware) { this.drawSoftware(matrix, camera, width, height); return; }
    gl.viewport(0, 0, width, height);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    gl.uniformMatrix4fv(this.uniforms.uMatrix, false, matrix);
    gl.uniform3fv(this.uniforms.uCamera, camera);
    gl.uniform3fv(this.uniforms.uMetal, this.metal || [.93, .95, 1]);
    gl.uniform2fv(this.uniforms.uLight, this.light);
    gl.drawArrays(gl.TRIANGLES, 0, this.vertexCount);
  }
  drawSoftware(matrix,camera,width,height){
    const started=performance.now();
    this.latestSoftwareFrame={matrix,camera,target:this.scene.center,width,height,metal:this.metal||[.93,.95,1],light:this.light,version:this.sceneVersion||0};
    this.pumpSoftwareFrame();
    this.dataset.softwareSubmitMs=String(Math.round(performance.now()-started));
  }
  pumpSoftwareFrame(){
    if(this.softwareBusy||!this.latestSoftwareFrame||!this.active)return;
    const request=this.latestSoftwareFrame;this.latestSoftwareFrame=null;this.softwareBusy=true;
    if(this.renderWorker){this.renderWorker.postMessage({type:'frame',request});return;}
    jbaSoftware.paintAsync(this.softwareState,request).then(duration=>{
      if(this.context2d&&this.active){this.context2d.clearRect(0,0,this.canvas.width,this.canvas.height);this.context2d.drawImage(this.softwareState.canvas,0,0);}
      this.finishSoftwarePaint({duration,version:request.version});
    }).catch(error=>{this.softwareBusy=false;this.dataset.errorReason=String(error?.message||error).slice(0,500);this.showStatus(this.dataset.unavailable,true);});
  }
  finishSoftwarePaint(message){
    this.softwareBusy=false;this.dataset.softwareFrameMs=String(message.duration);
    if(this.active&&message.version===(this.geometryVersion||0))this.finishReady();
    if(this.active)this.pumpSoftwareFrame();
  }
  snapshot() { if (!this.active || (!this.gl && !this.canvasSoftware)) return null; this.draw(); try{return this.canvas.toDataURL('image/png');}catch{return null;} }
}

if (!customElements.get('jba-jewel-viewer')) customElements.define('jba-jewel-viewer', JBAJewelViewer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jba-native-wishlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jba-native-wishlist')) customElements.define('jba-native-wishlist',class extends HTMLElement {
  connectedCallback() {
    if(this.ready)return;this.ready=true;this.container=this.closest('product-info');this.button=this.querySelector('button');
    try{this.optionNames=JSON.parse(this.querySelector('[data-option-names]').textContent)}catch{this.optionNames=[]}
    this.update=()=>{const item=this.item();this.button.disabled=!item||!window.JBAWishlist;const saved=Boolean(item&&window.JBAWishlist?.has(item));this.button.setAttribute('aria-pressed',String(saved));const label=saved?this.dataset.saved:this.dataset.save;if(this.button.querySelector('span').textContent!==label)this.button.querySelector('span').textContent=label};
    this.click=()=>{const item=this.item();if(item&&window.JBAWishlist)document.dispatchEvent(new CustomEvent('jba:wishlist-toggle',{detail:item}))};
    this.button.addEventListener('click',this.click);document.addEventListener('jba:wishlist-ready',this.update);document.addEventListener('jba:wishlist-updated',this.update);
    this.observer=new MutationObserver(records=>{if(records.some(record=>!this.contains(record.target))){cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(this.update)}});
    if(this.container)this.observer.observe(this.container,{childList:true,subtree:true});this.update();
  }
  disconnectedCallback(){this.observer?.disconnect();cancelAnimationFrame(this.frame);this.button?.removeEventListener('click',this.click);document.removeEventListener('jba:wishlist-ready',this.update);document.removeEventListener('jba:wishlist-updated',this.update);this.ready=false}
  item(){
    if(!this.container)return null;const variantNode=this.container.querySelector('variant-selects [data-selected-variant]');let variant;
    try{variant=variantNode?JSON.parse(variantNode.textContent):null}catch{return null}
    const form=this.container.querySelector('form[data-type="add-to-cart-form"]');const id=form?.querySelector('[name="id"]')?.value;
    if(!id||variant&&String(variant.id)!==String(id))return null;
    const chosen=Array.from(this.container.querySelectorAll('variant-selects .product-form__input')).map(group=>group.querySelector('input:checked,select')?.value).filter(value=>value!==undefined);
    if(variant&&chosen.length&&chosen.some((value,index)=>String(value)!==String(variant.options[index])))return null;
    const configuration={};this.optionNames.forEach((name,index)=>{const key=String(name).toLowerCase();const field=key.includes('production')?'production':key.includes('size')?'size':key.includes('metal')?'metal':key.includes('length')?'length':null;if(field&&variant?.options[index])configuration[field]=variant.options[index]});
    const url=new URL(this.dataset.productUrl,location.origin);url.searchParams.set('variant',id);
    return{id:this.dataset.productId,title:this.dataset.productTitle,url:url.pathname+url.search,variantId:id,image:variant?.featured_image?.src||this.dataset.productImage,configuration};
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jba-studio-recommendations"] && !Shopify.designMode) return;
  try {
    (() => {
  document.querySelectorAll('[data-pairing-order]').forEach(grid => { const order = grid.dataset.pairingOrder.split('|').filter(Boolean); [...grid.children].sort((a, b) => order.indexOf(a.dataset.styleId) - order.indexOf(b.dataset.styleId)).forEach(card => grid.append(card)); });
  const updatePairings = configuration => {
    if (!configuration?.metal) return;
    document.querySelectorAll('.jba-studio-pairing [data-recommendation-variants]').forEach(card => {
      let rows;
      try { rows = JSON.parse(card.dataset.recommendationVariants); } catch { return; }
      const matching = rows.find(row => row[1] === configuration.metal && row[0] === configuration.shape) || rows.find(row => row[1] === configuration.metal);
      if (!matching) return;
      card.querySelectorAll('a').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', matching[2]);
        if (configuration.ringSize && ['engagement-rings', 'eternity-bands'].includes(card.dataset.category)) url.searchParams.set('jba_size', String(configuration.ringSize));
        link.href = url.pathname + url.search;
      });
      const saveButton = card.querySelector('[data-jba-wishlist-item]');
      if (!saveButton) return;
      try {
        const item = JSON.parse(saveButton.dataset.jbaWishlistItem);
        item.variantId = matching[2];
        item.url = card.querySelector('a').getAttribute('href');
        item.configuration.metal = matching[1];
        item.configuration.shape = matching[0];
        if (configuration.ringSize && ['engagement-rings', 'eternity-bands'].includes(card.dataset.category)) item.configuration.size = String(configuration.ringSize);
        saveButton.dataset.jbaWishlistItem = JSON.stringify(item);
      } catch { }
    });
    window.JBAWishlist?.refresh?.();
  };
  document.addEventListener('jba:configuration-changed', event => updatePairings(event.detail));
  const product = document.querySelector('jba-studio-product');
  if (typeof product?.configuration === 'function') updatePairings(product.configuration());
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jba-wishlist-global"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.JBAWishlist) return;
  const storageKey = 'jba-wishlist-v1';
  const labelsNode = document.querySelector('[data-jba-wishlist-labels]');
  if (!labelsNode) return;
  let labels;
  try { labels = JSON.parse(labelsNode.textContent); } catch { return; }
  const clip = (value, max = 240) => typeof value === 'string' || typeof value === 'number' ? String(value).slice(0, max) : '';
  const cleanUrl = (value, image = false) => {
    if (!value || typeof value !== 'string') return '';
    try {
      const url = new URL(value, window.location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      if (image) {
        if (url.origin !== window.location.origin && url.hostname !== 'cdn.shopify.com' && !url.hostname.endsWith('.myshopify.com')) return '';
        return url.href;
      }
      if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products\/[^/]+\/?|products_preview\/?)$/i.test(url.pathname)) return '';
      return url.pathname + url.search + url.hash;
    } catch { return ''; }
  };
  const normalize = raw => {
    if (!raw || typeof raw !== 'object') return null;
    const item = { id: clip(raw.id, 120), title: clip(raw.title), url: cleanUrl(raw.url), image: cleanUrl(raw.image, true), variantId: clip(raw.variantId, 80), configuration: {} };
    if (!item.id || !item.title || !item.url) return null;
    const fields = ['shape', 'metal', 'carat', 'width', 'size', 'length', 'production'];
    fields.forEach(field => { const value = clip(raw.configuration?.[field], 80); if (value) item.configuration[field] = value; });
    item.key = JSON.stringify([item.id, item.variantId, item.configuration]);
    return item;
  };
  let items = [];
  let persistent = true;
  try {
    const raw = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(raw)) items = raw.slice(0, 100).map(normalize).filter(Boolean);
    localStorage.setItem(storageKey, JSON.stringify(items));
  } catch { persistent = false; }
  let timeout;
  const notify = text => {
    const notice = document.querySelector('[data-jba-wishlist-notice]');
    if (!notice) return;
    clearTimeout(timeout);
    notice.textContent = text;
    notice.hidden = false;
    timeout = setTimeout(() => { notice.hidden = true; }, 4000);
  };
  const readButton = button => { try { return normalize(JSON.parse(button.dataset.jbaWishlistItem)); } catch { return null; } };
  const update = () => {
    document.querySelectorAll('[data-jba-wishlist-count]').forEach(node => { node.textContent = items.length ? String(items.length) : ''; });
    document.querySelectorAll('[data-jba-wishlist-item]').forEach(button => {
      const item = readButton(button);
      const saved = Boolean(item && items.some(entry => entry.key === item.key));
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', (saved ? labels.unsave : labels.save).replace('__TITLE__', item?.title || ''));
    });
    document.dispatchEvent(new CustomEvent('jba:wishlist-updated', { detail: { items: items.map(item => ({ ...item, configuration: { ...item.configuration } })), persistent } }));
  };
  const persist = () => { if (persistent) try { localStorage.setItem(storageKey, JSON.stringify(items)); } catch { persistent = false; } update(); };
  const toggle = raw => {
    const item = normalize(raw);
    if (!item) return false;
    const index = items.findIndex(entry => entry.key === item.key);
    if (index >= 0) items.splice(index, 1);
    else { if (items.length >= 100) { notify(labels.limit); return false; } items.push(item); }
    persist();
    notify(persistent ? index >= 0 ? labels.removed : labels.saved : labels.temporary);
    return index < 0;
  };
  window.JBAWishlist = {
    toggle,
    refresh: update,
    has(raw) { const item = normalize(raw); return Boolean(item && items.some(entry => entry.key === item.key)); },
    getItems() { return items.map(item => ({ ...item, configuration: { ...item.configuration } })); },
    isPersistent() { return persistent; },
    remove(key) { items = items.filter(item => item.key !== key); persist(); notify(persistent ? labels.removed : labels.temporary); }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-jba-wishlist-item]');
    if (!button) return;
    const item = readButton(button);
    if (item) toggle(item);
  });
  document.addEventListener('jba:wishlist-toggle', event => { toggle(event.detail); });
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('storage', event => {
    if (event.key !== storageKey) return;
    try { const raw = JSON.parse(event.newValue || '[]'); if (Array.isArray(raw)) { items = raw.slice(0, 100).map(normalize).filter(Boolean); update(); } } catch { }
  });
  update();
  document.dispatchEvent(new CustomEvent('jba:wishlist-ready'));
})();
  } catch(e) { console.error(e); }
})();

})();
